import UpdateMenuAction from "../menu/update-menu-action";
import meshRestrictionController from "../../meshRestriction/meshRestrictionController";

class UserActionMoveObjects extends UpdateMenuAction {
    constructor(props) {
        super(props);
        this.highlightObjectWhenSelected = props.highlightObjectWhenSelected === true;
    }

    async execute() {
        GroupController.clearGroupDataForMove();
        const retainColor = !this.highlightObjectWhenSelected;
        meshRestrictionController.updateUserActionMoveObjectsRetainColor(retainColor);
        await super.execute();
    }

    async stop() {
        meshRestrictionController.updateUserActionMoveObjectsRetainColor(false);
        await super.stop();
        mController.updateMenuItemAction('MoveFeatureEnabled', false);
    }
}

export default UserActionMoveObjects;
